import { render, staticRenderFns } from "./InitialValueColumn.vue?vue&type=template&id=0b31d12c&functional=true"
import script from "./InitialValueColumn.vue?vue&type=script&lang=js"
export * from "./InitialValueColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports